import { render, staticRenderFns } from "./SucDatePeriodComponent.vue?vue&type=template&id=6199a47c&scoped=true&"
import script from "./SucDatePeriodComponent.vue?vue&type=script&lang=js&"
export * from "./SucDatePeriodComponent.vue?vue&type=script&lang=js&"
import style0 from "./SucDatePeriodComponent.vue?vue&type=style&index=0&id=6199a47c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6199a47c",
  null
  
)

export default component.exports